import script from "./loadingComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./loadingComp.vue?vue&type=script&lang=ts&setup=true"

import "./loadingComp.vue?vue&type=style&index=0&id=0d7fec13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7fec13"]])

export default __exports__